import { forwardRef } from "react";
import { IconResize } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
//#region src/TextArea/TextArea.elements.tsx
function Container({ className, children }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("[&_.textarea-error]:outline-system-error-50 [&_.textarea-error]:outline [&_.textarea-error]:outline-2 [&_.textarea-error]:!outline-offset-0", "[&_.textarea-error:focus-within]:shadow-[0px_0px_0px_4px_rgba(255,84,73,0.5)]", className),
		children
	});
}
const StyledTextAreaWrapper = forwardRef(({ disabled, readOnly, withError, className, children }, ref) => /* @__PURE__ */ jsx("div", {
	ref,
	"data-cy": "textArea-styledTextAreaWrapper",
	className: cn("bg-neutrals-95 relative flex items-center gap-2 rounded-[.875rem] pb-[.375rem] pl-3 pr-1 pt-2", "focus-within:outline-system-info-70 focus-within:outline focus-within:outline-2 focus-within:outline-offset-0", disabled && "bg-neutrals-80", readOnly && "bg-neutrals-80", withError && "outline-system-error-50 outline outline-2 !outline-offset-0", className),
	children
}));
StyledTextAreaWrapper.displayName = "StyledTextAreaWrapper";
function StyledLabel({ disabled, className, children, ...props }) {
	return /* @__PURE__ */ jsx("label", {
		className: cn("paragraph-sm text-type-common block pb-2", disabled && "text-[#998E8E] opacity-40", className),
		...props,
		children
	});
}
function StyledTextArea({ disabled, readOnly, resize = true, className, ...props }) {
	return /* @__PURE__ */ jsx("textarea", {
		"data-cy": "textArea-styledTextArea",
		className: cn("placeholder:text-type-light max-h-[60vh] min-h-[3rem] w-full cursor-auto bg-transparent pb-[.375rem] pr-3 pt-1 text-base text-inherit outline-none", "invalid:border-system-error-50", disabled && "placeholder:text-[#998E8E]", !resize && "resize-none", "[&::-webkit-scrollbar]:w-2", "[&::-webkit-scrollbar-thumb]:bg-neutrals-80 [&::-webkit-scrollbar-thumb]:rounded-[.625rem]", readOnly && "[&::-webkit-scrollbar-thumb]:bg-neutrals-60", "[&::-webkit-scrollbar-corner]:hidden", "[&::-webkit-resizer]:hidden", className),
		disabled,
		readOnly,
		...props
	});
}
function ResizeIcon() {
	return /* @__PURE__ */ jsx(IconResize, { className: "text-neutrals-60 pointer-events-none absolute bottom-[.375rem] right-1 size-2" });
}
//#endregion
export { Container, ResizeIcon, StyledLabel, StyledTextArea, StyledTextAreaWrapper };

//# sourceMappingURL=TextArea.elements.js.map